/* Navita · Completa o projeto (blocks/navita-completa.liquid) — upsell nativo.
   - "+" em cada cartão marca/desmarca o extra; mudar a opção também o marca.
   - "Adicionar os N · total": junta os extras (/cart/add.js) e depois clica no botão de compra do tema,
     que junta o produto principal, valida as cores das boxes e abre o carrinho lateral já com tudo.
   - Informa a barra do envio grátis (NavitaProduto.extras). */
if (!customElements.get('navita-completa')) {
  customElements.define(
    'navita-completa',
    class NavitaCompleta extends HTMLElement {
      connectedCallback() {
        if (this.dataset.pronto) return;
        this.dataset.pronto = '1';
        const lingua = document.documentElement.lang || 'pt-PT';
        this.dinheiro = new Intl.NumberFormat(lingua, { style: 'currency', currency: this.dataset.moeda || 'EUR' });

        this.addEventListener('click', (e) => {
          const mais = e.target.closest('[data-nc-escolha]');
          if (mais) {
            const card = mais.closest('[data-nc-item]');
            card.classList.toggle('is-escolhido');
            mais.setAttribute('aria-pressed', card.classList.contains('is-escolhido') ? 'true' : 'false');
            this.atualizar();
            return;
          }
          if (e.target.closest('[data-nc-botao]')) this.juntar();
        });
        this.addEventListener('change', (e) => {
          const card = e.target.closest('[data-nc-item]');
          if (card && e.target.matches('[data-nc-variante]')) {
            card.classList.add('is-escolhido');
            card.querySelector('[data-nc-escolha]')?.setAttribute('aria-pressed', 'true');
          }
          this.atualizar();
        });
        if (this.dataset.auto) this.carregarAutomaticos();
        else this.atualizar();
      }

      get form() {
        return document.getElementById(this.dataset.form);
      }

      precoDe(card) {
        const v = card.querySelector('[data-nc-variante]');
        const op = v.tagName === 'SELECT' ? v.selectedOptions[0] : v;
        return { id: Number(v.value), preco: Number(op?.dataset.preco) || 0 };
      }

      escolhidos() {
        return [...this.querySelectorAll('[data-nc-item].is-escolhido')].map((c) => this.precoDe(c));
      }

      principal() {
        const f = this.form;
        const unit = Number(document.querySelector('[data-navita-preco]')?.dataset.navitaPreco) || 0;
        const qtd = Math.max(1, Number(f?.querySelector('[name="quantity"]')?.value) || 1);
        return unit * qtd;
      }

      atualizar() {
        for (const c of this.querySelectorAll('[data-nc-item]')) {
          const p = c.querySelector('[data-nc-preco]');
          if (p) p.textContent = this.dinheiro.format(this.precoDe(c).preco / 100);
        }
        const ex = this.escolhidos();
        const soma = ex.reduce((a, x) => a + x.preco, 0);
        const total = this.dinheiro.format((this.principal() + soma) / 100);
        const botao = this.querySelector('[data-nc-botao]');
        const resumo = this.querySelector('[data-nc-resumo]');
        if (ex.length) {
          botao.disabled = false;
          botao.textContent = this.dataset.txtBotao.replace('[n]', ex.length + 1).replace('[total]', total);
          resumo.innerHTML = this.dataset.txtResumo.replace('[n]', ex.length).replace('[total]', `<b>${total}</b>`);
        } else {
          botao.disabled = true;
          botao.textContent = this.dataset.txtBotaoVazio;
          resumo.textContent = this.dataset.txtDica;
        }
        if (window.NavitaProduto) {
          window.NavitaProduto.extras = soma;
          window.NavitaProduto.envio?.();
        }
      }

      async juntar() {
        if (this.ocupado) return;
        const f = this.form;
        const botaoTema = document.querySelector(`.product-information .add-to-cart-button`);
        if (!botaoTema || botaoTema.disabled) return;
        // cores da box em falta, etc.: o próprio botão do tema mostra o aviso
        if (f && !f.checkValidity()) { botaoTema.click(); return; }
        const extras = this.escolhidos();
        if (!extras.length) return;
        this.ocupado = true;
        const aviso = this.querySelector('.navita-up__aviso');
        try {
          const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: extras.map((x) => ({ id: x.id, quantity: 1 })) }),
          });
          if (!r.ok) throw new Error((await r.json()).description || r.status);
          for (const c of this.querySelectorAll('[data-nc-item].is-escolhido')) {
            c.classList.remove('is-escolhido');
            c.querySelector('[data-nc-escolha]')?.setAttribute('aria-pressed', 'false');
          }
          aviso.hidden = true;
        } catch (erro) {
          aviso.hidden = false;
          aviso.textContent = String(erro.message || erro);
        }
        this.atualizar();
        botaoTema.click(); // o tema junta o produto principal e abre o carrinho
        this.ocupado = false;
      }

      /* Sem produtos escolhidos à mão: recomendações automáticas da Shopify ("related"). */
      async carregarAutomaticos() {
        try {
          const raiz = window.Shopify?.routes?.root || '/';
          const dados = await fetch(`${raiz}recommendations/products.json?product_id=${this.dataset.auto}&limit=8&intent=related`).then((r) => r.json());
          const lista = this.querySelector('[data-nc-lista]');
          const excluir = (this.dataset.excluir || '').split(',');
          const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
          let n = 0;
          for (const p of dados.products || []) {
            if (n >= Number(this.dataset.autoLimite || 3)) break;
            if (excluir.includes(p.handle)) continue;
            const disp = p.variants.filter((v) => v.available);
            if (!disp.length) continue;
            n++;
            const t = p.title.toLowerCase();
            const etiqueta = /kit|bundle|bag|box/.test(t) ? this.dataset.txtProjeto : this.dataset.txtCombina;
            const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=480` : '';
            const opcoes = p.variants.length === 1
              ? `<input type="hidden" data-nc-variante value="${disp[0].id}" data-preco="${disp[0].price}">`
              : `<select class="navita-up__opcao" data-nc-variante aria-label="${esc(this.dataset.txtOpcao)} ${esc(p.title)}">${disp.map((v) => `<option value="${v.id}" data-preco="${v.price}">${esc(v.title)}</option>`).join('')}</select>`;
            lista.insertAdjacentHTML('beforeend', `
              <article class="navita-up__card" data-nc-item>
                <div class="navita-up__foto">${img ? `<img src="${img}" alt="" loading="lazy" width="480" height="480">` : ''}
                  <span class="navita-up__pilula">${esc(etiqueta)}</span>
                  <button type="button" class="navita-up__mais" data-nc-escolha aria-pressed="false" aria-label="${esc(this.dataset.txtJuntar)} ${esc(p.title)}"><span class="navita-up__mais-mais" aria-hidden="true">+</span><span class="navita-up__mais-certo" aria-hidden="true">✓</span></button>
                </div>
                <a class="navita-up__nome" href="${p.url}">${esc(p.title)}</a>
                ${opcoes}
                <p class="navita-up__preco" data-nc-preco></p>
              </article>`);
          }
          if (n) this.hidden = false;
        } catch (e) { /* sem recomendações: o bloco fica escondido */ }
        this.atualizar();
      }
    }
  );
}
